import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private showHeaderSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private showFooterSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private showSidebarSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private showLoginButtonSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private showRegisterButtonSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  showHeader$: Observable<boolean> = this.showHeaderSubject.asObservable();
  showFooter$: Observable<boolean> = this.showFooterSubject.asObservable();
  sideBar$: Observable<boolean> = this.showSidebarSubject.asObservable();
  showLoginButton$: Observable<boolean> = this.showLoginButtonSubject.asObservable();
  showRegisterButton$: Observable<boolean> = this.showRegisterButtonSubject.asObservable();


  setShowHeader(show: boolean): void {
    this.showHeaderSubject.next(show);
  }

  setShowFooter(show: boolean): void {
    this.showFooterSubject.next(show);
  }

  setShowSidebar(show: boolean): void {
    this.showSidebarSubject.next(show);
  }

  setShowLoginButton(show: boolean): void {
    this.showLoginButtonSubject.next(show);
  }

  setShowRegisterButton(show: boolean): void {
    this.showRegisterButtonSubject.next(show);
  }
  constructor() { }
}
